import {getToken} from '@/utils/auth';
import {getInfoApproved, postConsultApply} from "@/api/company";
import {beforeRouteNameMap} from "~/config/textConfig";
import {uMengConfig} from "~/config/uMengConfig";

export const applyMixin = {
  methods: {
    applyFor() {
      let beforePath = this.$route.matched[0].path
      let myUrl = `/inquiry?beforePath=${beforePath}`
      // 如果是企业账号查询，则进行友盟的统计
      if (beforePath.includes('wwzs/enterprise')) {
        this.$initUMeng.buriedPointUm(uMengConfig.wEnterprise_consult_click.name)
      }
      //已经登陆
      if (getToken()) {
        getInfoApproved().then(res => {
          if (res.code === 0) {
            if (res.data && typeof res.data !== 'string') { //已认证
              let params = res.data
              params.phone=params.encryptPhone
              params.email=params.encryptEmail
              try{
                params.interestProduct = beforeRouteNameMap.get(beforePath)
              }catch (e) {}
              postConsultApply(params).then(res => {
                if (res.code === 0) {
                  this.$store.commit('REAPPLY_ALERT', true);
                } else {
                  this.$message(res.msg);
                }
              })
            } else { //未认证
              this.$router.push(myUrl)
            }
          }
        })
      } else { //未登录
        this.$router.push(myUrl)
      }
    }
  }
}
